"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function AboutVisual() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="235680" id="posicionamento" className="bg-background text-foreground py-20 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div ref={textRef} className={`flex flex-col gap-8 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-6">
              <p className="text-muted-foreground font-default text-lg md:text-xl leading-relaxed">
                Localizado no coração de Pinheiros, nosso estúdio combina tecnologia de ponta com um ambiente acolhedor. Desenvolvemos um ecossistema focado na alta performance criativa para artistas e produtores exigentes. Nossa abordagem integra o melhor do áudio analógico e digital, garantindo que cada projeto tenha uma identidade sonora única e profissional, elevando o padrão da produção musical independente.
              </p>
            </div>

            <div className="pt-6 flex flex-wrap gap-4">
              <Button asChild size="lg" className="font-default bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg">
                <Link to="https://itcmais.com/o-estudio/" newTab>
                  Conheça o Estúdio
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="font-default border-primary text-primary hover:bg-primary/5 rounded-lg">
                <Link to="https://itcmais.com/sobre/">
                  Nossa História
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}